import { useMemo } from 'react';
import type { ReactNode } from 'react';
import type Rollbar from 'rollbar';
import { useRollbar } from '@rollbar/react';
import {
  RhinoErrorReporterContext,
  type RhinoErrorReporter
} from '@rhino-project/core/lib';

/**
 * Bridge Rollbar into Rhino's error reporter context so package-level error
 * boundaries report through Rollbar. Render inside RollbarProvider.
 */
export const RollbarReporterProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const rollbar = useRollbar();
  const reporter = useMemo<RhinoErrorReporter>(
    () => ({
      report: (error, context) =>
        context
          ? rollbar.error(error as Rollbar.LogArgument, context)
          : rollbar.error(error as Rollbar.LogArgument)
    }),
    [rollbar]
  );

  return (
    <RhinoErrorReporterContext value={reporter}>
      {children}
    </RhinoErrorReporterContext>
  );
};
